import React, { useCallback } from 'react';
import classes from './LanguageSwitcher.module.scss';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const LanguageSwitcher = ({ setLanguage, changeUserLanguage }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const changeLanguage = useCallback((lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    changeUserLanguage(lang);
    dispatch({ type: 'User/UPDATE', payload: { language: lang } });

    document.documentElement.lang = lang;
  }, []);

  return (
    <Space style={{ zIndex: 99999 }}>
      <div
        className={`${classes.item} ${i18n.language === 'lv' ? classes.active : ''}`}
        onClick={() => changeLanguage('lv')}
      >
        LV
      </div>
      <div
        className={`${classes.item} ${i18n.language === 'en' ? classes.active : ''}`}
        onClick={() => changeLanguage('en')}
      >
        EN
      </div>
    </Space>
  );
};

export default LanguageSwitcher;
